module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_8011.9ebf78b5.png";